(() => {
 const initialize = root => root.querySelectorAll('[data-mr-stimuli]').forEach(section => {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const videos = [...section.querySelectorAll('[data-mr-stimuli-video]')];
  const visible = new Set(), paused = new WeakSet();
  const sync = video => {
   const button = video.parentElement.querySelector('[data-mr-stimuli-toggle]');
   button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
   button.querySelector('[data-pause-icon]').toggleAttribute('hidden', video.paused);
   button.querySelector('[data-play-icon]').toggleAttribute('hidden', !video.paused);
  };
  const play = video => {
   if (!video.getAttribute('src')) video.src = video.dataset.src;
   video.muted = true;
   video.play().catch(() => sync(video));
  };
  const start = video => {
   if (!reduced.matches && !document.hidden && !paused.has(video)) play(video);
  };
  videos.forEach(video => {
   const button = video.parentElement.querySelector('[data-mr-stimuli-toggle]');
   button.hidden = false;
   button.addEventListener('click', () => {
    if (video.paused) { paused.delete(video); play(video); }
    else { paused.add(video); video.pause(); }
   });
   video.addEventListener('play', () => sync(video));
   video.addEventListener('pause', () => sync(video));
   sync(video);
  });
  const observer = new IntersectionObserver(entries => {
   entries.forEach(entry => {
    if (entry.isIntersecting) { visible.add(entry.target); start(entry.target); }
    else { visible.delete(entry.target); entry.target.pause(); }
   });
  }, { threshold: 0.55 });
  videos.forEach(video => observer.observe(video));
  document.addEventListener('visibilitychange', () => {
   if (document.hidden) videos.forEach(video => video.pause());
   else visible.forEach(start);
  });
  reduced.addEventListener('change', () => {
   if (reduced.matches) videos.forEach(video => video.pause());
   else visible.forEach(start);
  });
  document.addEventListener('shopify:section:unload', event => {
   if (event.target.contains(section)) { observer.disconnect(); videos.forEach(video => video.pause()); }
  }, { once: true });
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document)); else initialize(document);
 document.addEventListener('shopify:section:load', event => initialize(event.target));
})();